import React from "react";
import CreateDiscussionTopic from "../../../Components/DiscussionForum/CreateDiscussionTopic/CreateDiscussionTopic";

function CreateDiscussion() {
  return (
    <div>
      <CreateDiscussionTopic />
    </div>
  );
}

export default CreateDiscussion;
